<template>
    <div>
        <div v-if="fetching">
            <loading size="small"></loading>
        </div>

        <div v-else class="mb-16">

            <div class="rounded bg-primary-5 border border-primary-20 pt-16 pl-16 mb-24">
                <div class="mb-16 mr-16">
                    <toggle v-model="filterFields.inclusiveTagMode">
                        {{ $t('applications.filters.all_tag_results') }}
                    </toggle>
                </div>
            </div>

            <div class="pl-16 mr-16">
                <select-dropdown
                    v-model="filterFields.tagIds"
                    reference="id"
                    label="title"
                    :auto-translate="false"
                    :multiple="true"
                    :searchable="true"
                    :loading="false"
                    :options="applicationTags"
                    :placeholder="$t('form.dropdown.placeholder')"
                    remove-icon
                >
                </select-dropdown>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from '../ui/Loading.vue';
import Tag from '../../models/Tag';
import Toggle from '../forms/Toggle.vue';
import * as tags from '../../services/TagService';
import { normalizeJson } from '../../../shared/helpers';
import SelectDropdown from "../forms/SelectDropdown";
import {useRepo} from 'pinia-orm';

export default {
    components: {
        'loading': Loading,
        'toggle': Toggle,
        SelectDropdown,
    },
    props: {
        filterFields: Object
    },
    data: function () {
        return {
            fetching: true,
            andMode: true,
        }
    },
    computed: {
        applicationTags () {
            return useRepo(Tag)
                .orderBy('title')
                .get()
        }
    },
    methods: {
        fetch () {
            this.fetching = true;

            tags.index()
                .then(result => {
                    return useRepo(Tag).save(normalizeJson(result.data));
                })
                .then(result => {
                    this.fetching = false;
                });
        }
    },
    mounted () {
        this.fetch();
    }
}
</script>
